module.exports = __webpack_public_path__ + "static/media/vr_experience.a37c8b4f.png";